import classNames from 'classnames';
import { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { SERVICE_ORDER_ROUTE } from '../../../routes/routes';
import { LabelledInfoCell } from '../../../sharedComponents/sidebar/LabelledInfoCell';
import { Vehicle } from '../../compoundManagement.types';
import { OptionalFormattedDate } from '../../../sharedComponents/OptionalFormattedDate';

type CompoundVehicleVINProps = {
    vehicle: Vehicle;
};

export const CompoundVehicleVIN: FunctionComponent<CompoundVehicleVINProps> = ({ vehicle }) => (
    <>
        <div
            className={classNames(
                'border-color-light',
                'bg-lightest',
                'display-flex',
                'gap-25',
                'padding-top-25',
                'padding-left-25',
            )}
        >
            <LabelledInfoCell
                labelMessageId="outboundOrderBook.common.heading.vin"
                className="text-size-16 text-medium"
            >
                {vehicle.vin}
            </LabelledInfoCell>
            <LabelledInfoCell
                labelMessageId="outboundOrderBook.common.sidebar.details.vehicle.manufacturedAt"
                className="text-size-16"
            >
                <OptionalFormattedDate date={vehicle.manufacturedAt} />
            </LabelledInfoCell>
        </div>
        <div
            className={classNames(
                'border-color-light',
                'border-style-solid',
                'border-width-1',
                'border-bottom-only',
                'bg-lightest',
                'display-flex',
                'gap-25',
                'padding-bottom-25',
                'padding-left-20',
            )}
        >
            <a type="button" className="btn btn-link btn-xs" href={`#${SERVICE_ORDER_ROUTE}?vin=${vehicle.vin}`}>
                <span className="rioglyph rioglyph-document" aria-hidden="true" />
                <span>
                    <FormattedMessage id="outboundOrderBook.compoundManagement.sidebar.linkToServiceOrders" />
                </span>
            </a>
        </div>
    </>
);
